import { apiClient } from './apiClient';

export interface ImpersonationStatus {
  is_impersonating: boolean;
  tenant_id?: string;
  tenant_name?: string;
}

export const impersonationService = {
  async getImpersonationStatus(): Promise<ImpersonationStatus> {
    const data = await apiClient.get('/impersonation-status/') as ImpersonationStatus;
    return {
      is_impersonating: data.is_impersonating ?? false,
      tenant_id: data.tenant_id,
      tenant_name: data.tenant_name,
    };
  },

  async stopImpersonation(): Promise<{ redirect_to: string }> {
    const data = await apiClient.post('/stop-impersonation/', {}) as { message: string; redirect_to: string };
    return { redirect_to: data.redirect_to || '/platform/admin/dashboard' };
  },
};
